<div class="folder" [ngClass]="{ 'edit': folder.editing, 'shared': folder.is_shared }">
  <span *ngIf="!folder.editing" class="folder-title">{{folder.title}}</span>
  <input autofocus (keyup.enter)="save(folder)" [hidden]="!folder.editing" #editFolderInput type="text" class="form-control folder-input" [(ngModel)]="tmpFolderTitle" placeholder="New Folder Name"/>

  <div *ngIf="folder.editing" class="folder-menu">
    <span (click)="folder.editing=false" class="fa fa-times-circle-o fa-2x"></span>
    <span (click)="save(folder)" [ngClass]="{'disabled' : !tmpFolderTitle}" class="fa fa-check-circle fa-2x"></span>
  </div>

  <div class="shared" *ngIf="shareable && folder.is_shared && !folder.read_only" (click)="openShareModal(folder)">
    <i class="fa fa-user-o"></i>
  </div>

  <div *ngIf="!folder.editing" class="folder-menu">
    <div ngbDropdown class="d-inline-block dropup" [placement]="'top'">
      <span class="fa fa-ellipsis-h toggle-points" id="folderMenu" ngbDropdownToggle></span>
      <div class="dropdown-menu dropdown-menu-right" aria-labelledby="folderMenu">
        <ng-container *ngIf="shareable">
          <button class="dropdown-item" *ngIf="!folder.read_only" (click)="openShareModal(folder)"><i class="fa fa-chain"></i> Share</button>
          <button class="dropdown-item text-danger" *ngIf="folder.is_shared && folder.subscription" (click)="unSubscribeFolder($event, folder)" [disabled]="folder.unsubscribing"><i class="fa fa-share"></i> Unsubscribe <i class="fa fa-spin fa-spinner" *ngIf="folder.unsubscribing"></i></button>
        </ng-container>
        <ng-container *ngIf="!folder.read_only">
          <button class="dropdown-item" (click)="editMode(folder)"><i class="fa fa-pencil"></i> Edit Name</button>
          <!--button class="dropdown-item"><i class="fa fa-files-o"></i> Duplicate</button-->
          <button class="dropdown-item" (click)="deleteFolder(folder)"><i class="fa fa-trash"></i> Delete</button>
        </ng-container>
      </div>
    </div>

    <span *ngIf="!folder.editing" (click)="folder.collapsed = !folder.collapsed" [ngClass]="{'fa-angle-down': folder.collapsed, 'fa-angle-up': !folder.collapsed}" class="collapse-arrow fa fa-2x"></span>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-list/folder/folder.component.html